import { ErrorHandler, NgModule } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { QuillModule } from 'ngx-quill';

import { effects, getInitialState, reducers } from '®app/ngrx';
import { environment } from '®environments/environment';
import { AuthModule } from '®shared/auth';
import { AppConfig, configureApp } from '®shared/config';
import { CurrentUserModule } from '®shared/current-user';
import { EventsModule } from '®shared/events';
import { LoaderModule } from '®shared/loader';
import { LtiRelinkModule } from '®shared/lti-relink';
import { NavbarModule } from '®shared/navbar';
import { DragulaModule } from '®shared/ng2-dragula';
import { ErrorReportingModule } from '®shared/reporting/error-reporting.module';
import { TenantModule } from '®shared/tenant';

import { AppErrorHandler } from './app-error-handler.service';
import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { ErrorPageModule } from './error-page';
import { LtiMissingContentModule } from './lti/lti-missing-content/lti-missing-content.module';
import { PageNotFoundModule } from './page-not-found';
import { ItemModeResolverModule } from './reading-lists/item-view/mode-resolver';
import { ListModeResolverModule } from './reading-lists/list/mode-resolver';
import { SectionModeResolverModule } from './reading-lists/section-view/mode-resolver';
import { RedirectAuthenticationComponent } from './redirect-authentication/redirect-authentication.component';
import { metaReducers } from './redux-logger';

// configure main module
@NgModule({
  declarations: [AppComponent, RedirectAuthenticationComponent],
  imports: [
    AuthModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    CollapseModule.forRoot(),
    CurrentUserModule.forRoot(),
    BsDropdownModule.forRoot(),
    DragulaModule.forRoot(),
    EffectsModule.forRoot(effects),
    ErrorPageModule,
    EventsModule.forRoot(),
    ListModeResolverModule,
    LoaderModule,
    LtiRelinkModule,
    ItemModeResolverModule,
    ModalModule.forRoot(),
    NavbarModule,
    LtiMissingContentModule,
    PageNotFoundModule,
    QuillModule.forRoot(),
    SectionModeResolverModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
      initialState: getInitialState,
    }),
    StoreRouterConnectingModule.forRoot(),
    environment.production ? [] : StoreDevtoolsModule.instrument(),
    TenantModule,
    TooltipModule.forRoot(),
    ErrorReportingModule,
    routing,
    MatMomentDateModule,
  ],
  providers: [
    { provide: AppConfig, useFactory: configureApp },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    Title,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
